enum TextType {
  h1 = "h1",
  h2 = "h2",
  h3 = "h3",
  thead = "thead",
  important = "important",
  text = "text",
  date = "date",
  link = "link",
  secondary = "secondary",
  error = "error",
  disabled = "disabled",
  warning = "warning",
}
export default TextType;
